import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import PlanCard from "./PlanCard";
import { getSubscriptionPlans } from "../../api/Subscribers/subscriptionPlan";
import Disclaimer from "../BankInfo/Disclaimer";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { subscriberTrial } from "../../api/Subscribers/subscriber";
import { isStripe } from "../../utils/paymentProvider";

export const SubscriptionCard = () => {
  const navigate = useNavigate();
  const [plans, setPlans] = useState(null);
  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [subscriptionType, setSubscriptionType] = useState("");
  const [alreadySubscribed, setAlreadySubscribed] = useState(false);
  const userData = JSON.parse(localStorage.getItem("data"));
  const userTypeData = useSelector((state) => state?.common?.newUser?.data);
  const fullUser = useSelector((state) => state?.common?.fullUser);
  // Under Stripe the card is collected by Checkout, so a linked sending/bank
  // account is no longer a prerequisite to subscribe.
  const hasSendingAccount = isStripe() || fullUser?.sendingAccountVerify;
  const handleUserClick = (planId) => {
    if (hasSendingAccount && !fullUser?.subscribed) {
      navigate(planId ? `/subscription?plan=${planId}` : "/subscription");
    } else if (
      fullUser?.subscribed &&
      subscriptionType == "trial" &&
      !fullUser?.nextSubscription &&
      hasSendingAccount
    ) {
      setAlreadySubscribed(true);
      return true;
    } else {
      setSubscriptionModal(true);
    }
  };
  useEffect(() => {
    // Plans load for everyone, signed in or not. The endpoint is public, so a
    // logged-out visitor finally sees real prices here instead of a "free trial"
    // placeholder standing in for a number we could not fetch.
    loadPlans();
    if (userData) {
      subType();
    }
  }, []);
  const subType = async () => {
    const res = await subscriberTrial();
    setSubscriptionType(res);
  };
  const loadPlans = async () => {
    setPlans(await getSubscriptionPlans());
  };
  const handleModalClick = () => {
    if (userData?.user_type === "homeowner") {
      navigate("/add-hom-account");
    } else {
      navigate("/payment-options");
    }
  };

  return (
    <>
      {subscriptionType === "privilege" ||
      subscriptionType === "temporary_privilege" ? (
        ""
      ) : (
        <>
          <div className="w-100 d-flex justify-content-center align-items-center mt-5">
            <span className="subscription-heading">
              <FormattedMessage id="subscription" />
            </span>
            <span className="subscription-heading2">
              <FormattedMessage id="plan" />
            </span>
          </div>
          {plans !== null && plans.length === 0 ? (
            <div className="subscription-empty">
              <FormattedMessage id="plans_unavailable" />
            </div>
          ) : null}
          <div className="subscription-plans-grid">
            {(plans || []).map((plan) => (
              <PlanCard
                key={plan.id}
                plan={plan}
                showTrial={!userData || !fullUser?.subscribed}
                onCta={() =>
                  userData
                    ? handleUserClick(plan.id)
                    : navigate("/welcome")
                }
                ctaLabel={
                  !userData ? (
                    <FormattedMessage id="register" />
                  ) : subscriptionType === "trial" ? (
                    <FormattedMessage id="using_free_trail" />
                  ) : subscriptionType === "paid" && fullUser?.subscribed ? (
                    <FormattedMessage id="subscribed" />
                  ) : (
                    <FormattedMessage id="subscribe" />
                  )
                }
              />
            ))}
          </div>
        </>
      )}
      <Disclaimer
        showModal={subscriptionModal}
        setShowModal={() => setSubscriptionModal(false)}
        body={
          fullUser?.subscribed &&
          !fullUser?.nextSubscription &&
          subscriptionType === "paid" ? (
            <FormattedMessage id="already_subscribe" />
          ) : fullUser?.subscribed &&
            fullUser?.nextSubscription &&
            subscriptionType === "paid" ? (
            <FormattedMessage id="already_subscribed" />
          ) : (
            <FormattedMessage id="add_sender_account" />
          )
        }
        confirmText={
          fullUser?.subscribed &&
          !fullUser?.nextSubscription &&
          subscriptionType === "paid" ? (
            ""
          ) : fullUser?.subscribed &&
            fullUser?.nextSubscription &&
            subscriptionType === "paid" ? (
            <FormattedMessage id="unsubscribe" />
          ) : (
            <FormattedMessage id="add" />
          )
        }
        cancelText={
          fullUser?.subscribed &&
          !fullUser?.nextSubscription &&
          subscriptionType === "paid" ? (
            <FormattedMessage id="ok" />
          ) : (
            <FormattedMessage id="cancel" />
          )
        }
        handleClick={() => {
          fullUser?.subscribed &&
          fullUser?.nextSubscription &&
          subscriptionType === "paid"
            ? navigate("/subscription")
            : handleModalClick();
        }}
        handleCancel={() => setSubscriptionModal(false)}
      />
      <Disclaimer
        showModal={alreadySubscribed}
        setShowModal={() => setAlreadySubscribed(false)}
        body={<FormattedMessage id="free_trail" />}
        confirmText={<FormattedMessage id="subscribe" />}
        cancelText={<FormattedMessage id="cancel" />}
        handleClick={() => navigate("/subscription")}
        handleCancel={() => setAlreadySubscribed(false)}
      />
    </>
  );
};
